import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  MeteringDeviceIndicatorCreateModel,
  MeteringDeviceIndicatorParams,
  MeteringDeviceIndicatorReadModelSlim,
} from './types';

export const meteringDeviceIndicatorApi = createApi({
  reducerPath: 'meteringDeviceIndicatorApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-device-indicators`,
  }),
  tagTypes: ['MeteringDeviceIndicator'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getMeteringDeviceLastIndicator: builder.query<
      MeteringDeviceIndicatorReadModelSlim,
      MeteringDeviceIndicatorParams
    >({
      query: params => ({
        url: `/last`,
        params,
      }),
      providesTags: () => ['MeteringDeviceIndicator'],
    }),
    createMeteringDeviceIndicator: builder.mutation<
      string,
      MeteringDeviceIndicatorCreateModel
    >({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
      invalidatesTags: ['MeteringDeviceIndicator'],
    }),
  }),
});

export const {
  useGetMeteringDeviceLastIndicatorQuery,
  useCreateMeteringDeviceIndicatorMutation,
} = meteringDeviceIndicatorApi;
